<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-window">

      <button class="close-btn" @click="close">×</button>

      <img src="../assets/edit-request.png" class="modal-icon" />

      <h2 class="modal-title">Запрос на редактирование</h2>

      <p class="modal-text">
        Вы сможете редактировать данные компании сразу после проверки вашим профилем модератором.
        Отправить запрос на проверку?
      </p>

      <button
        class="submit-btn"
        @click="send"
        :disabled="isLoading"
      >
        <span v-if="isLoading" class="loader shimmer"></span>
        <span v-else>Отправить запрос</span>
      </button>

    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import CompanyService from "../api/CompanyService";

const emit = defineEmits(["close", "submit", "success"]);

const props = defineProps({
  companyId: { type: String, required: true }
});

const loading = ref(false);

async function send() {
  try {
    loading.value = true;
    await CompanyService.requestCompanyEditAccess(props.companyId);

    emit("success"); 
    emit("close");  

  } catch (e) {
    console.error("Ошибка:", e);
  } finally {
    loading.value = false;
  }
}

function close() {
  emit("close");
}
</script>

<style scoped>
/* Затемнение */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9990;
  backdrop-filter: blur(2px);
}

/* Окно */
.modal-window {
  background: linear-gradient(180deg, #2887F7 0%, #174F91 100%);
  padding: 28px;
  width: 380px;
  border-radius: 24px;
  position: relative;
  text-align: center;
  color: white;
  box-shadow: 0px 14px 32px rgba(0,0,0,0.25);
  animation: fadeIn 0.25s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.92); }
  to   { opacity: 1; transform: scale(1); }
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 12px;
  font-size: 24px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: white;
  opacity: 0.8;
  transition: 0.2s;
}

.close-btn:hover { opacity: 1; }

.modal-icon {
  width: 33px;
  height: 40px;
  margin-bottom: 8px;
}

.modal-title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 10px;
}

.modal-text {
  font-size: 14px;
  line-height: 1.12;
  opacity: 0.95;
  margin-bottom: 26px;
  padding: 0 8px;
}

/* КНОПКА */
.submit-btn {
  background: white;
  color: #1B5FCC;
  border: none;
  width: 100%;
  padding: 12px;
  border-radius: 12px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 700;
  transition: 0.2s ease;
  box-shadow: 0px 4px 12px rgba(255,255,255,0.25);
  display: flex;
  justify-content: center;
  align-items: center;
}

.submit-btn:hover { background: #f1f1f1; }
.submit-btn:disabled { opacity: 0.65; cursor: default; }

/* SHIMMER LOADER */
.loader {
  width: 70%;
  height: 14px;
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    #ffffff30 0%,
    #ffffff80 50%,
    #ffffff30 100%
  );
  animation: shimmer 1s infinite linear;
}

@keyframes shimmer {
  0% { background-position: -150px 0; }
  100% { background-position: 150px 0; }
}
</style>